import { searchJobs } from '../../../api/portal-api';
import { withSearchBlueprint } from '../../blueprints/search';

export const { reducer, ...jobSearch } = withSearchBlueprint('jobSearch', null, {
  endpoint: searchJobs,
  defaultSort: [{ id: 'name', desc: false }],
  globalSearchIndices: [
    'name',
    'number',
    'owner.full_name',
    'department.name',
    'status'
  ],
  pageSize: 25
});
